import { Inject, Injectable, Optional } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS } from '@angular/material-luxon-adapter';
import { DateTime } from 'luxon';
import { UserService } from 'taxtank-core';

@Injectable()
export class ZonedDateAdapter extends LuxonDateAdapter implements DateAdapter<DateTime> {
  timezone = this.userService.getCacheFirst()?.clientDetails?.timezone;

  constructor(
    @Optional() @Inject(MAT_DATE_LOCALE) locale: string,
    @Optional() @Inject(MAT_LUXON_DATE_ADAPTER_OPTIONS) options: any,
    private userService: UserService
  ) {
    super(locale, options);
  }

  override format(date: DateTime, displayFormat: string): string {
    if (this.timezone) {
      date = date.setZone(this.timezone);
    }

    return super.format(date, displayFormat);
  }
}
